import React from 'react';
import { connect } from 'react-redux';
import { CanvasPrint } from './slide/CanvasPrint';
import { PrintMenu } from './menus/PrintMenu';
import storeManager from '../store/StoreManager';
import styles from './AppPrint.scss';
import canvasScale from '../components/utils/CanvasScaleUtils';

const AppPrintWrapper = React.createClass({
    render () {
        if (this.props.slides == undefined)
            return <div/>;

        const scaleProperties = canvasScale.getPrintScaleProperties(this.props.windowWidth, this.props.windowHeight);

        var elements = [];
        var slideModel;
        var i;

        const holderStyle = {
            pageBreakAfter: 'always',
            float: 'none'
        };

        if (this.props.printTemplate == 0) {
            var pageElements = [];
            var count = 0;

            for (i = 0; i < this.props.slides.length; i++) {
                count = count + 1;

                slideModel = this.props.slides[i];
                pageElements.push(<CanvasPrint printTemplate={this.props.printTemplate} slideModel={slideModel} index={count} dispatch={this.props.dispatch} scaleProperties={scaleProperties} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} key={'appPrint' + i}/>);

                if (count % 3 == 0) {
                    elements.push(
                        <div style={holderStyle}>
                            {pageElements}
                        </div>
                    );

                    pageElements = [];
                    count = 0;
                }
            }

            if (count > 0) {
                elements.push(
                    <div style={holderStyle}>
                        {pageElements}
                    </div>
                );
            }
        } else {
            for (i = 0; i < this.props.slides.length; i++) {
                slideModel = this.props.slides[i];
                elements.push(<div style={holderStyle} key={'appPrintElements' + i}>
                                <CanvasPrint printTemplate={this.props.printTemplate} slideModel={slideModel} index={i} dispatch={this.props.dispatch} scaleProperties={scaleProperties} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>
                              </div>);
            }
        }

        var printMenu;

        if (this.props.printMode == false)
            printMenu = <PrintMenu windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} dispatch={this.props.dispatch}/>;

        return (
            <div id='app' className={styles.app}>
                {elements}
                {printMenu}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const store = storeManager.getStore();
    const slides = state.production.slides;
    let windowWidth = state.production.windowWidth;
    let windowHeight = state.production.windowHeight;
    let printTemplate = state.menu.printTemplate;
    let printMode = state.menu.printMode;

    if (!(windowWidth > 0))
        windowWidth = window.innerWidth;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    if (printTemplate == undefined)
        printTemplate = 0;

    if (printMode == undefined)
        printMode = false;

    return {
        dispatch: store.dispatch,
        windowWidth,
        windowHeight,
        slides,
        printTemplate,
        printMode
    };
}

export const AppPrint = connect(mapStateToProps)(AppPrintWrapper);



/** WEBPACK FOOTER **
 ** ./src/components/AppPrint.js
 **/